// TODO: Break this into discrete functions, per AJS styleguide
(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.playlist.config.routes'

  require('angular')
    .module(MODULE_NAME, [
      require('@uirouter/angularjs').default,
      require('../../content'),
      require('../../expandedContent')
    ])
    .config(routesConfig)

    // TODO: this whole thing needs to be revisited!
  routesConfig.$inject = ['$stateProvider', '$urlRouterProvider']
  function routesConfig ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/')
    /*
        $stateProvider
            .state('playlist', {
                url : '/tm/playlist'
            })
            .state('playlist.content', {
                // TODO: using 'content' as a URL base could cause collisons... Perhaps we namespace our routes with 'tm'? https://www.example.com/#!/tm/content/:content_id
                url    : '/:playlist_id/:content_id',
                onEnter : ['$state', '$stateParams', 'ExpandedContent', 'PlaylistContent', 'Content', 'analyticsSDK', function ($state, $stateParams, ExpandedContent, PlaylistContent, Content, analyticsSDK) {
                    PlaylistContent
                        .get({playlist_id: $stateParams.playlist_id, content_id: $stateParams.content_id},
                            function (response) {
                                Content.addContent('deepLinks', response.data);
                                // TODO: Should this actually be here?
                                // analyticsSDK.eventTrack('Content Viewed', {ccmtContentId: response.data.id, trigger: 'deeplinked'});
                                ExpandedContent.open(
                                    response.data.content,
                                    { displayShare: true }, // The assumption here is if this is being reached through a shared URL that sharing is OK to display.
                                    returnHome,             // We want to go home, regardless of what happens when this modal's done.
                                    returnHome
                                );
                            },
                            returnHome
                        );

                        function returnHome() {
                            $state.go('glow.page');
                        }
                    }]
                }
            );
        */
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/playlist/config/routes.js